import { Box } from '@chakra-ui/core';
import React from 'react';

const QuestionContainer: React.FC<{
  level: number;
  header: React.ReactNode;
  children: React.ReactNode;
}> = ({ level, header, children }) => {
  return (
    <Box
      border="1px solid"
      borderColor="brand_200"
      borderRadius="md"
      ml={level * 6}
      overflow="hidden"
      boxShadow="0px 2px 4px rgba(0, 0, 0, 0.04)"
    >
      <Box px={4} py={3}>
        {header}
      </Box>

      <Box height="1px" bg="brand_200" width="100%" />
      <Box px={4} py={3}>
        {children}
      </Box>
    </Box>
  );
};

export default QuestionContainer;
